import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1e5d922e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Notifications ", -1))
const _hoisted_3 = { class: "focusContainer" }
const _hoisted_4 = { class: "items" }
const _hoisted_5 = {
  key: 0,
  class: "noNotifications"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "focusContainer" }

import { computed, ComputedRef, Ref, ref } from 'vue';
import { RouteLocationRaw } from 'vue-router';

import PopupMenu, { PopupMenuApi } from '@/components/dialogs/popupmenu/PopupMenu.vue';
import { useNotifications } from '@/composables/notification/Notifications';
import { Notification } from '@/data/datatypes/Notification';
import NotificationNavListItem from '@/navigation/NotificationNavListItem.vue';
import RouteNames from '@/router/RouteNames';

interface Props {
  above?: boolean;
}
interface Emits {
  (e: 'close'): void,
  (e: 'clearAllNotifications'): void,
  (e: 'notificationClicked'): void,
  (e: 'notificationDeleted'): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsPopup',
  props: {
    above: { type: Boolean, default: false }
  },
  emits: ["close", "clearAllNotifications", "notificationClicked", "notificationDeleted"],
  setup(__props: any, { emit: __emit }) {

const { allNotifications } = useNotifications();



const emit = __emit;

const popupMenu: Ref<PopupMenuApi | null> = ref(null);

const notificationsRoute: ComputedRef<RouteLocationRaw> = computed(() => {
  return {
    name: RouteNames.NOTIFICATIONS_ROUTE_NAME
  };
});

function close(): void {
  // It is necessary to close the popupMenu manually as it has been populated via slots
  popupMenu.value?.close();
  emit('close');
}

function removeAllConfirm(): void {
  // clear all notifications
  close();
  emit('clearAllNotifications');
}

function notificationClicked(): void {
  // notify clicked
  close();
  emit('notificationClicked');
}

function notificationDeleted(notification: Notification): void {
  if (notification.deleteHandler) {
    notification.deleteHandler();
  }
  emit('notificationDeleted');
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(PopupMenu, {
    class: "notificationsPopup",
    ref_key: "popupMenu",
    ref: popupMenu,
    onSubMenuClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    horizontalPosition: 'left',
    verticalPosition: _ctx.above ? 'above' : 'below'
  }, {
    menuOpener: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_unref(allNotifications).length > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "clearAll",
                onClick: _withModifiers(removeAllConfirm, ["prevent","stop"])
              }, " Clear all "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allNotifications), (notification) => {
          return (_openBlock(), _createElementBlock("li", {
            key: notification.id
          }, [
            _createVNode(NotificationNavListItem, {
              notification: notification,
              onClick: notificationClicked,
              onDeleted: ($event: any) => (notificationDeleted(notification))
            }, null, 8, ["notification", "onDeleted"])
          ]))
        }), 128)),
        _createElementVNode("li", null, [
          (_unref(allNotifications).length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " You have no notifications "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      (_unref(allNotifications).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                class: "footerLink",
                to: notificationsRoute.value,
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" View all notifications ")
                ], undefined, true),
                _: 1
              }, 8, ["to"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["verticalPosition"]))
}
}

})